/**
 * @Author ZhangYing
 * @Date 2022-04-26 08:45:15
 * @LastEditors ZhangYing
 * @LastEditTime 2022-04-29 14:52:34
 * @Description  根据 bmFrom plainSceneId 或 channel 来判断场景
 * @FilePath /BM-Main/src/utils/bmFromScene.js
 * @props
 */
import { url } from '@zz-common/zz-utils'
import { MODEL_PAGE_SCENE_MAP } from '@/conf/enum.conf'
import native from '@zz-common/native-adapter'
import { isExternalRecycle, isExternalEnv, inALI_PAY, inGAODE, inZLJ } from '@/utils/env';

const { bmFrom, bmfrom, plainSceneId, channel = '', onlyPhone, webShowType, wvHalfVer, appId, userInfo } = url.getParams() || {}
const __from = bmFrom || bmfrom || plainSceneId
const __channel = channel || ''
console.log('__from&__channel: ', __from, __channel);
export const bmfromQuery = __from
// 以旧换新场景（zlj）：1、展示【手机】【平板】品类，2、隐藏批量下单入口
export const isB2COld2NewScene = __from === 'B2COld2New'
// C2C 以旧折扣场景（仅转转）
export const isC2COld2CashScene = __from === 'C2COld2Cash'
// 使用半层
export const isHalfViewScene = (webShowType == 1 || wvHalfVer == 'v2') && (native.in('zz') || native.in('zlj'))
// 估价领现金活动场景
export const isActEvaluateScene = __from === 'ACT-EVALUATE-FOR-MONEY'
// b2c下回收场景
export const isB2COrderScene = __from === 'b2c-order'
// 省心快卖场景：1、展示【更多】品类
export const isSXKMScene = __from && __from.includes('SXKM')
// 报价单场景：1、仅展示手机品类
export const isOnlyPhoneScene = onlyPhone == 1
// 转转回收车：1、隐藏批量下单入口，2、过滤寄卖品类并提示toast不可选，3、估价后携带参数跳回回收车
export const isRecycleCarScene = __from === 'recycleCar'
// 电池健康度查询
export const isLotterySearchScene = __from === 'lotterySearch'
// 寄卖机型列表场景：跳转至估价页后不进入卖法卡片及回收下单页，指定进入寄卖下单页
export const isConsignModelListScene = __from === 'consignModelList'
// C2C 寄卖场景
export const isC2CConsignScene = String.prototype.startsWith.call(__channel, 'JM_')
// C2C 主发布入口
export const isC2CMainPublishScene = __from === 'mainPublish'
// 聚合回收场景：展示显卡、内存、固态硬盘、CPU
export const isAggregateRecycleScene = __from === 'aggregateRecycle'
// 摄影器材场景：展示单反、镜头、微单
export const isPhotographyRecycleScene = __from === 'photographyRecycle'
// 双11大促
export const isPromotionNovScene = __from === 'promotionNov'
//笔记本简易估价
export const isSimpleEvaluate = __from === 'laptopSimpleEvaluate'
// 身价估算器
export const isWorthEvaluateScene = __from === 'worthEvaluate'
// 新媒体运营工具
export const isNewMediaGenerateOrdersScene = __from === 'newMediaGenerateOrders'

// 使用半层的那些场景
export const matchHalfViewScene = (isB2COld2NewScene || isC2COld2CashScene || isPromotionNovScene || isRecycleCarScene || isWorthEvaluateScene || isNewMediaGenerateOrdersScene) &&
isHalfViewScene

// 根据不同场景为机型页提供默认的 modelPageSceneId
export const getDefaultModelPageSceneId = async() => {
  const { NORMAL, NORMAL_ZLJ, RECYCLE_CAR, OLD_TO_NEW, OLD_TO_CASH, GAO_DE, KUAI_SHOU } = MODEL_PAGE_SCENE_MAP
  let defaultModelPageSceneId = inZLJ ? NORMAL_ZLJ : NORMAL
  if (isB2COld2NewScene) {
    defaultModelPageSceneId = OLD_TO_NEW
  } else if (isRecycleCarScene || isPromotionNovScene) {
    defaultModelPageSceneId = RECYCLE_CAR
  } else if (isC2COld2CashScene) {
    defaultModelPageSceneId = OLD_TO_CASH
  } else if (await isExternalRecycle() || inALI_PAY) {
    defaultModelPageSceneId = GAO_DE
  } else if (isExternalEnv) {
    defaultModelPageSceneId = KUAI_SHOU
  }
  return defaultModelPageSceneId
}

// 高德静默登录的场景
export const isGaodeSilentLoginScene = inGAODE && appId && userInfo
